import VehiclesError from './VehiclesError.js'

export class GetSubscriptionMakesVehiclesError extends VehiclesError {}
